import { AuthHooks } from 'common/hooks';
import { useAppSelector } from 'app/store/store.hooks';
import { selectCurrentUser } from 'entities/User/User.slice';
import { selectXBasketId } from 'entities/Auth/Auth.slice';

const useCurrentBasketId = (): number | null => {
  // auth
  const xBasketId = useAppSelector(selectXBasketId);
  // user
  const currentUser = useAppSelector(selectCurrentUser);

  const { isSeller } = AuthHooks.useIsSeller();

  if (isSeller) {
    return xBasketId ? xBasketId : null;
  }

  return currentUser ? currentUser.basketId : null;
};

export const BasketHooks = {
  useCurrentBasketId,
};
